import { InitiativeLink } from '@types';

import { createGetEndpoint, getQueryString } from '@sonar-software/sonar-http';
import { DynamicQueryParams, KeyPaginationQueryParams, PaginatedResource } from '@sonar-software/sonar-ts-types';

export type GetInitiativeLinksRequest = KeyPaginationQueryParams & DynamicQueryParams & {
	initiativeId: number;
};

export type GetInitiativeLinksResponse = PaginatedResource<InitiativeLink>;

export const getInitiativeLinks = createGetEndpoint<GetInitiativeLinksRequest, GetInitiativeLinksResponse>(
	({ initiativeId, ...rest }) => `/api/v3/initiatives/${initiativeId}/links?${getQueryString(rest)}`
);
